export class User {
    _id: number;
    firstName: string;
    lastName: string;
    email: string;

    constructor(data) {
        Object.assign(this, data);
    }

    get name() {
        return [this.firstName, this.lastName].join(' ');
    }
}
